export default __webpack_public_path__ + "static/backgroundImage-d143cc73e55d352db67d9dd5cbc572ab.png";